import { render } from "./CapsuleToys.vue?vue&type=template&id=eaca9d1a&scoped=true"
import script from "./CapsuleToys.vue?vue&type=script&lang=js"
export * from "./CapsuleToys.vue?vue&type=script&lang=js"

import "./CapsuleToys.vue?vue&type=style&index=0&id=eaca9d1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eaca9d1a"]])

export default __exports__